<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;

  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/entities-attribute-association-list">Entities Attribute Association List</a></li>
      <li class="breadcrumb-item active" aria-current="page">New Entities Attribute Association</li>
    </ol>
  </nav>
</div>

<div class="container">
  <form class="form-horizontal mt-1" [formGroup]="attributeForm">
    <div class="row">
      <div class="col-md-10 col-xl-7">

        <div class="card mt-1">

          <div class="card-body">


            <div class="form-group">
              <label for="attributeForm">Entity Name <span style="color:red">*</span></label>
              <select formControlName="eid" class="form-control formstyle"
                      [ngClass]="{ 'is-invalid': submitted && f.eid.errors }"  (change)="getEntityAttribute($event.target.value)">

                <option value="">Please Select Entity</option>
                <option *ngFor="let userObj of entities" value={{userObj.entity_id}}>
                  {{userObj.entity_name}}
                </option>
              </select>
              <div *ngIf="submitted && f.eid.errors" class="invalid-feedback">
                <div *ngIf="f.eid.errors.required">Entity is required</div>
              </div>
            </div>

            <div class="form-group" *ngIf="show">
              <label for="attributeForm">Attribute Name</label>
              <div class="piInnerList scroller">
                <ul class="filtMain">
                  <li *ngFor="let item of attrList">
                    <div class="row">
                      <div class="col-9">
                        <label class="form-check-label">
                          {{item.field_name}}
                        </label>
                      </div>

                      <div class="col-3">

                        <input  [checked]="checkForIdInList(item.field_id)" [value]="item.field_id" [name]="item.field_name"  type="checkbox"  (change)="selectAttributes($event, item.field_id)">

                      </div>

                    </div>

                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="card-footer text-center ">
            <div class="my_class text-center">
              <button type="submit" class="custbtn" *ngIf="isWrite" (click)="addAttribute()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
